import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { ApolloQueryResult } from 'apollo-client'
import { SourceName } from '.'

export const sourceNamesQuery = gql`
  query SourceNames($organizationID: ID!) {
    sourceNames(organizationID: $organizationID) {
      id
      name
      start
      expiration
      cidrBlocks
      modified
      expired
    }
  }
`

export type SourceNamesLoaderRefetchFn = (
  variables?:
    | {
        readonly organizationID: string
      }
    | undefined
) => Promise<ApolloQueryResult<any>>

export interface ChildProps {
  readonly loading: boolean
  readonly sourceNames: SourceName[]
  readonly refetch: () => Promise<any>
}

interface Props {
  readonly organizationID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function SourceNamesLoader({ organizationID, children }: Props) {
  return (
    <Query
      query={sourceNamesQuery}
      variables={{ organizationID }}
      errorPolicy="all"
    >
      {(result) => {
        const { data, error, loading, refetch } = result
        if (error) {
          throw new Error(error.message)
        }
        const sourceNames: SourceName[] =
          !!data && !!data.sourceNames
            ? data.sourceNames.map(
                ({
                  id,
                  name,
                  start,
                  expiration,
                  cidrBlocks,
                  modified,
                  expired
                }) => ({
                  id,
                  name,
                  start,
                  expiration,
                  cidrBlocks,
                  modified,
                  expired
                })
              )
            : []
        return children({
          loading,
          sourceNames,
          refetch
        })
      }}
    </Query>
  )
}
